import { 
  ShieldIcon, 
  SettingsIcon, 
  FileArchiveIcon, 
  EyeIcon, 
  ActivityIcon,
  ScrollTextIcon,
  BriefcaseIcon
} from 'lucide-react';
import type { NavigationSectionConfig } from './types';

/**
 * System Administration Navigation Section
 * Roles & Permissions, Settings, Database, Job Management, Monitoring, Health Check, Audit Logs
 */
export const systemAdminSections: NavigationSectionConfig[] = [
  {
    id: 'system-admin-section',
    label: 'System Administration',
    topNavId: 'system-admin',
    items: [
      {
        id: 'roles',
        label: 'Roles & Permissions',
        path: '/admin/roles',
        icon: <ShieldIcon size={18} />,
        permissions: ['nav:roles']
      },
      {
        id: 'settings',
        label: 'Settings',
        path: '/admin/settings',
        icon: <SettingsIcon size={18} />,
        permissions: ['nav:settings'],
        disabled: true
      },
      {
        id: 'database',
        label: 'Database Management',
        path: '/admin/database',
        icon: <FileArchiveIcon size={18} />,
        permissions: ['nav:database']
      },
      {
        id: 'job-management',
        label: 'Job Management',
        path: '/admin/jobs',
        icon: <BriefcaseIcon size={18} />,
        permissions: ['nav:jobs']
      },
      {
        id: 'monitoring',
        label: 'Monitoring',
        path: '/admin/monitoring',
        icon: <EyeIcon size={18} />,
        permissions: ['nav:monitoring'],
        disabled: true
      },
      {
        id: 'health-check',
        label: 'Health Check',
        path: '/staticHealthDashboard.html',
        icon: <ActivityIcon size={18} />,
        permissions: ['nav:health-check']
      },
      {
        id: 'audit',
        label: 'Audit Logs',
        path: '/admin/audit',
        icon: <ScrollTextIcon size={18} />,
        permissions: ['nav:audit']
      }
    ]
  }
];

